import { useLocation } from "react-router-dom";
import Footer from "./Footer/Footer";
import MarketplaceFooter from "./Routes/Marketplace/components/MarketplaceFooter";
import { isMarketplaceRoute } from "./Routes/Marketplace/libs/isMarketplaceRoute";
const SiteFooter = () => {
  const { pathname } = useLocation();
  return isMarketplaceRoute(pathname) ? <MarketplaceFooter /> : <Footer />;
};

export default SiteFooter;
